import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import messages from "./local";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: messages,
    lng: "zh",
    fallbackLng: "zh",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "navigator", "htmlTag"],
      lookupFromPathIndex: 0,
    },
  });

export default i18n;